import React from "react";
import { Button, Group, Select } from "@mantine/core";

import {
  Subtree,
  SubtreeBody,
  SubtreeHeader,
} from "@piqnt/runtime-core/react/Subtree";
import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";
import { DraftIcon } from "@piqnt/runtime-core/react/Icon";

import { SpaceContext } from "../space";

import { getKey, type PlainBody } from "@piqnt/runtime-space/drawing-model";

interface FixtureCreateProps {
  body: PlainBody;
  title?: string;
}

const fixtureTypes = [
  { type: "circle", name: "Circle" },
  { type: "box", name: "Box" },
  { type: "polygon", name: "Polygon" },
  { type: "chain", name: "Chain" },
  { type: "edge", name: "Edge" },
  { type: "bezier", name: "Bezier Curve" },
];

export const FixtureCreate = (props: FixtureCreateProps) => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const editable = context.editable.value;

  const [shapeType, setShapeType] = React.useState(null as string);

  const createDraft = React.useCallback(() => {
    emit("fixture-draft", {
      body: getKey(props.body),
      fixture: { shape: { type: shapeType } },
    });
  }, [shapeType]);

  if (!editable || !props.body) return null;

  return (
    <Subtree open>
      <SubtreeHeader>{props.title ?? "createFixture"}</SubtreeHeader>
      <SubtreeBody>
        <Group gap={4}>
          <Select
            placeholder="..."
            onChange={(type) => setShapeType(type)}
            data={fixtureTypes.map((shapeType) => ({
              value: shapeType.type,
              label: shapeType.name,
            }))}
            size="xs"
            w={100}
          />
          <Button size="xs" variant="default" onClick={createDraft}>
            <DraftIcon />
          </Button>
        </Group>
      </SubtreeBody>
    </Subtree>
  );
};
